import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceField, TextField } from "react-admin";

const CampaignTypeField = ({ subTypeId }) => {
  return (
    <ReferenceField
      source="typeId"
      filter={{ SubTypeId: subTypeId }}
      reference={candidateRequests.getCampaignTypesSelect()}
    >
      <TextField source="name" />
    </ReferenceField>
  );
};

export default CampaignTypeField;
